import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const KeyValueStack = ({ items }) => (
  <Stack direction="row" spacing="2vw">
    {items?.map(({ key, value }) => (
      <Stack key={key} spacing={0} direction="column">
        <Typography variant="small_2" fontWeight={500} color="gray.A600">{key}</Typography>
        <Typography variant="small_2" fontWeight={400} color="gray.A600">{value}</Typography>
      </Stack>
    ))}
  </Stack>
);

KeyValueStack.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default KeyValueStack;
